// A versao de cache (`?v=2`) nao e montada aqui: cada `.favicon` ja chega com
// o href definitivo, query incluida, de app/views/layouts/vueapp.html.erb.
// Este helper so troca o nome do arquivo entre o favicon normal e o de
// badge, preservando o que o layout escreveu.
const rememberOriginalHref = favicon => {
  if (!favicon.dataset.originalHref) {
    favicon.dataset.originalHref = favicon.getAttribute('href');
  }
};

export const showBadgeOnFavicon = () => {
  const favicons = document.querySelectorAll('.favicon');

  favicons.forEach(favicon => {
    rememberOriginalHref(favicon);
    favicon.href = favicon.dataset.originalHref.replace(
      '/favicon-',
      '/favicon-badge-'
    );
  });
};

export const initFaviconSwitcher = () => {
  const favicons = document.querySelectorAll('.favicon');

  favicons.forEach(favicon => rememberOriginalHref(favicon));

  document.addEventListener('visibilitychange', () => {
    if (document.visibilityState === 'visible') {
      favicons.forEach(favicon => {
        favicon.href = favicon.dataset.originalHref;
      });
    }
  });
};
